import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import ArticleCard from "@/components/feature/ArticleCard";
import SectionTitle from "@/components/feature/SectionTitle";
import { getCategoryName, sortByDate } from "@/utils/articles";

export default function FeaturedSection() {
  const list = sortByDate(articles);
  const lead = list[0];
  const rest = list.slice(1, 7);

  return (
    <section className="bg-background-100" aria-labelledby="featured-title">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-14 md:px-8 md:py-20">
        <SectionTitle
          eyebrow="编辑精选"
          title={<span id="featured-title">最近更新的猛料合集</span>}
          description="每一条都配了背景梳理和进展更新，不是一句话标题党。"
          action={
            <Link
              to="/materials"
              className="inline-flex items-center gap-1.5 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
            >
              浏览全部
              <i className="ri-arrow-right-line" />
            </Link>
          }
        />

        <div className="grid grid-cols-1 gap-5 lg:grid-cols-12 lg:gap-6">
          <div className="lg:col-span-7">
            <ArticleCard article={lead} categoryName={getCategoryName(lead.categoryId)} variant="overlay" />
          </div>
          <div className="flex flex-col gap-4 lg:col-span-5 lg:justify-between">
            {rest.slice(0, 3).map((item) => (
              <ArticleCard
                key={item.id}
                article={item}
                categoryName={getCategoryName(item.categoryId)}
                variant="horizontal"
              />
            ))}
          </div>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 lg:gap-6">
          {rest.slice(3).map((item) => (
            <ArticleCard key={item.id} article={item} categoryName={getCategoryName(item.categoryId)} />
          ))}
        </div>
      </div>
    </section>
  );
}